import { render, staticRenderFns } from "./NewDiscussion.vue?vue&type=template&id=5509975a&"
import script from "./NewDiscussion.vue?vue&type=script&lang=js&"
export * from "./NewDiscussion.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./NewDiscussion.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports